import React, { useState } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Login from '../pages/login';

import Inicio from '../pages/inicio';

import PasswordRecover from '../pages/passwordRecover';
import Mantenimiento from '../pages/usuarios/mantenimiento';
import CargaMasiva from '../pages/usuarios/cargaMasiva';
import NuevoCapi from '../pages/usuarios/nuevoCapi';
import NuevaEmpresa from '../pages/usuarios/nuevaEmpresa';
import Dashboard from '../pages/usuarios/dashboard';
import PerfilUsuario from '../pages/perfilUsuario';
import UbicacionCapis from '../pages/ubicacionCapis';
import InfoCapisInv from '../pages/invitado/informacionCapisInv';
import UbicacionCapisInv from '../pages/invitado/ubicacionCapisInv';
import DatosTrabajador from '../pages/form/datosTrabajador';
import DatosHijos from '../pages/form/datosHijos';
import DefinicionServicio from '../pages/form/definicionServicio';
import BeneficiarioDatosTrabajador from '../pages/invitado/form/datosTrabajadorInv';
import BeneficiarioDatosHijos from '../pages/invitado/form/datosHijosInv';
import BeneficiarioDefinicionServicio from '../pages/invitado/form/definicionServicioInv';
import Beneficiario from '../pages/invitado/inicioInv';
import NuevaSucursal from '../pages/usuarios/nuevaSucursal';
import VistaDatosCapis from '../pages/usuarios/vistaCrudCapis';
import VistaDatosEmpresas from '../pages/usuarios/vistaCrudEmpresas';
import VistaDatosSucursales from '../pages/usuarios/vistaCrudSucursales';
import VistaDatosColaboradores from '../pages/usuarios/vistaCrudColaboradores';
import InformacionCapis from '../pages/form/informacionCapis';
import EditarCapi from '../pages/usuarios/editarCapi';
import EditarEmpresa from '../pages/usuarios/editarEmpresa';
import EditarSucursal from '../pages/usuarios/editarSucursal';
import EditarColaborador from '../pages/usuarios/editarColaborador';
import DetallesDepartamento from '../pages/detallesDeptoCapis';
import BeneficiarioDetallesDepartamento from '../pages/invitado/detallesDeptoCapisInv';
import Navbar from '../components/navbar';
import FormularioDatosTrabajador from '../formData/formularioDatosTrabajador';
import FormularioHijos from '../formData/formularioHijos';

function Router() {
	const [isNavbarExpanded, setIsNavbarExpanded] = useState(false);

	const location = useLocation();
	// console.log(location);
	return (
		<div className="flex min-h-screen">
			{location.pathname !== '/' &&
				<Navbar isExpanded={isNavbarExpanded} setIsExpanded={setIsNavbarExpanded} />
			}
			<div
				className={
					`max-w-full flex-grow transition-all duration-300 ${location.pathname !== '/' ? (isNavbarExpanded ? 'md:ml-[100px]' : 'md:ml-[100px]') : '' }`
				}
			>
				<Routes>
					<Route path="/" element={<Login />} />
					<Route path="/PasswordRecover" element={<PasswordRecover />} />
					<Route path="/reset/:token" element={<PasswordRecover />} />
					<Route path="/Inicio" element={<Inicio />} />
					
					<Route path="/DatosTrabajador" element={<DatosTrabajador />} />
					<Route path="/DatosHijos" element={<DatosHijos />} />
					<Route path="/DefinicionServicio" element={<DefinicionServicio />} />

					<Route path="/Mantenimiento" element={<Mantenimiento />} />
					<Route path="/CargaMasiva" element={<CargaMasiva />} />
					<Route path="/Dashboard" element={<Dashboard />} />
					<Route path="/NuevoCapi" element={<NuevoCapi />} />
					<Route path="/VistaDatosCapis" element={<VistaDatosCapis />} />
					<Route path="/EditarCapi/:id" element={<EditarCapi />} />
					<Route path="/NuevaEmpresa" element={<NuevaEmpresa />} />
					<Route path="/VistaDatosEmpresas" element={<VistaDatosEmpresas />} />
					<Route path="/EditarEmpresa/:id" element={<EditarEmpresa />} />
					<Route path="/NuevaSucursal" element={<NuevaSucursal />} />
					<Route path="/VistaDatosSucursales" element={<VistaDatosSucursales />} />
					<Route path="/EditarSucursal/:id" element={<EditarSucursal />} />
					<Route path="/UbicacionCapis" element={<UbicacionCapis />} />
					<Route path="/DetallesDepartamento/:id" element={<DetallesDepartamento />} />
					<Route path="/InformacionCapis" element={<InformacionCapis />} />
					<Route path="/PerfilUsuario" element={<PerfilUsuario />} />
					<Route path="/Beneficiario" element={<Beneficiario />} />
					<Route path="/UbicacionCapisInv" element={<UbicacionCapisInv />} />
					<Route path="/Beneficiario_DetallesDepto/:id" element={<BeneficiarioDetallesDepartamento />} />
					<Route path="/InfoCapisInv" element={<InfoCapisInv />} />

					<Route path="/Beneficiario_DatosTrabajador" element={<FormularioDatosTrabajador />} />
					<Route path="/Beneficiario_DatosHijos" element={<FormularioHijos />} />
					<Route path="/Beneficiario_DefinicionServicio" element={<BeneficiarioDefinicionServicio />} />
					
					<Route path="/VistaDatosColaboradores" element={<VistaDatosColaboradores />} />
					<Route path="/EditarColaborador/:id" element={<EditarColaborador />} />
				</Routes>
			</div>
		</div>
	)
}

export default Router;